import * as React           from "react";

import "./office-mailing-assets-route.scss";

import {XdSentry}          from "@Common/libs/sentry/xd-sentry";
import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {BubbleNoti}        from "@Common/ui-components/bubble-noti/bubble-noti";

import {BRANCH_LEVEL}    from "../../../../common/logic/user-level";
import {NoPermit}        from "../../../common/bulk-mail-permit/no-permit/no-permit";
import {MultiInputModal} from "../../../common/multi-input-modal/multi-input-modal";

export const BulkMailPermitCard = ({bulkMailPermit, officeId, userLevel}) => cs(
    // ["confirmClose", (_, next) => ConfirmExitDialog({next})],
    ["bubbleNoti", (_, next) => BubbleNoti({next})],
    consumeContext("apis"),
    ["editPermitModal", ({apis, bubbleNoti}, next) => MultiInputModal({
        next,
        title: "Bulk Mail Permit",
        labelLocation: "left",
        onSave: async (updatePermitFields) => {
            if(
                !updatePermitFields.line1 ||
                !updatePermitFields.line2 ||
                !updatePermitFields.line3
            ) {
                return {errorTop: "Permit information is not complete. Per USPS standards, permit must have at least 3 lines."};
            } 
            else {
                try {
                    const result = await apis.next.bulkMailPermit.saveIndicia({
                        agentId: officeId, 
                        userLevel: BRANCH_LEVEL,
                        id: bulkMailPermit?.value?.idPrimary ?? 0,
                        indicia: updatePermitFields,
                    });
                    bubbleNoti.show({
                        message: `Success! Bulk mail permit successfully ${bulkMailPermit?.value?.idPrimary ? 'updated' : 'added'}.`,
                        color: "green",
                    });
                    return result;
                }
                catch(error) {
                    if ((typeof error)=="string") {
                        return {errorMessage: error};
                    } 
                    else {
                        XdSentry.captureException(error);
                        return {errorMessage: "An unexpected error occurred."};
                    }
                }
            }
        },
        reload: async () => {
            await bulkMailPermit?.reload();
        }
    })],
    ({editPermitModal}) => (
        <>
            <span className="bulk-mail-permit-span">
                <h5 className="bulk-mail-permit-header" xd-qa-type="label" xd-qa-name="Manage Bulk Mail Permit">Manage Bulk Mail Permit</h5>
                <a 
                    className="bulk-mail-permit-edit"
                    onClick={() => editPermitModal.show({
                        data: [
                            {"label": <div>Line 1 <span style={{color: "red"}}>*</span></div>, "value": bulkMailPermit?.value?.line1 ?? "", "mapping": "line1", "maxLength": "40"},
                            {"label": <div>Line 2 <span style={{color: "red"}}>*</span></div>, "value": bulkMailPermit?.value?.line2 ?? "", "mapping": "line2", "maxLength": "40"},
                            {"label": <div>Line 3 <span style={{color: "red"}}>*</span></div>, "value": bulkMailPermit?.value?.line3 ?? "", "mapping": "line3", "maxLength": "40"},
                            {"label": "Line 4", "value": bulkMailPermit?.value?.line4 ?? "", "mapping": "line4", "maxLength": "40"},
                            {"label": "Line 5", "value": bulkMailPermit?.value?.line5 ?? "", "mapping": "line5", "maxLength": "40"},
                        ],
                    })}
                    xd-qa-type="link"
                    xd-qa-name="Edit Bulk Mail Permit"
                >
                    {bulkMailPermit?.value?.idPrimary || bulkMailPermit.loading.value || bulkMailPermit?.loading ? "Edit" : "Add"}
                </a>
            </span>
            <div className="bulk-mail-permit-card">
                {
                    (bulkMailPermit?.value?.line1 || bulkMailPermit?.value?.line2 || bulkMailPermit?.value?.line3)
                    ?
                    <div className="bulk-mail-permit-active">                       
                        <div className="bulk-mail-permit-text" xd-qa-type="text" xd-qa-name={bulkMailPermit?.value?.line1}>{bulkMailPermit?.value?.line1}</div>
                        <div className="bulk-mail-permit-text" xd-qa-type="text" xd-qa-name={bulkMailPermit?.value?.line2}>{bulkMailPermit?.value?.line2}</div>
                        <div className="bulk-mail-permit-text" xd-qa-type="text" xd-qa-name={bulkMailPermit?.value?.line3}>{bulkMailPermit?.value?.line3}</div>
                        <div className="bulk-mail-permit-text" xd-qa-type="text" xd-qa-name={bulkMailPermit?.value?.line4}>{bulkMailPermit?.value?.line4}</div>
                        <div className="bulk-mail-permit-text" xd-qa-type="text" xd-qa-name={bulkMailPermit?.value?.line5}>{bulkMailPermit?.value?.line5}</div>                                              
                    </div>
                    :
                    <>
                    {
                        NoPermit()
                    }                        
                    </>                    
                }      
            </div>
        </>
    )
);